import { FC } from "react";
import { Show } from "shared/components";

type Props = {
  title: string;
  icon?: JSX.Element;
};

export const SelectLabel: FC<Props> = ({ icon, title }) => {
  return (
    <div className="flex items-center gap-2">
      <Show if={Boolean(icon)}>{icon}</Show>
      <p className="text-sm font-medium text-content-1000">{title}</p>
    </div>
  );
};
